import React from "react";
import { useState } from "react";
import PrimaryButton from "../../components/PrimaryButton";
import { Card, Col, Form, Row } from "react-bootstrap";
import PaginationComponent from "../../components/PaginationComponent";
import useReplenishmentRequestDetailsViewController from "../../viewControllers/ReplenishmentRequestViewController/ReplenishmentRequestDetailsViewController";
import Loader from "../../components/Loader";
import i18n from "../../constants/Strings";
import ReplenishmentRequestDetailsTable from "./ReplenishmentRequestDetailsTable";
import { replenishmentRequestDetailsTableHeaders } from "../../constants/TableConstants";
import { formatDateTime } from "../../utils/helpers";
import InputField from "../../components/InputField";
import SearchIcon from "@mui/icons-material/Search";

const ReplenishmentRequestDetails = () => {
  const {
    requestId,
    loading,
    currentPage,
    totalPages,
    handlePageChange,
    toggleIsEditing,
    handleKeyDown,
    requestItems,
    createdAt,
    updatedAt,
    sublocationName,
    approvalStatus,
    updateQuantity,
    handleQuantityChange,
    goBack,
    handleApprove,
    handleReject,
    searchText,
    setSearchText,
    filteredItems,
    totalFilteredCount,
    searchLoading,
    filter,
    setFilter,
  } = useReplenishmentRequestDetailsViewController();

  const text = {
    backBtn: i18n.t("replenishmentRequests.requestDetails.backBtn"),
    viewDetails: i18n.t("replenishmentRequests.requestDetailsviewDetails"),
    requestID: i18n.t("replenishmentRequests.requestDetails.requestID"),
    requestTime: i18n.t("replenishmentRequests.requestDetails.requestTime"),
    storeName: i18n.t("replenishmentRequests.requestDetails.storeName"),
    approveBtn: i18n.t("replenishmentRequests.requestDetails.approveBtn"),
    rejectBtn: i18n.t("replenishmentRequests.requestDetails.rejectBtn"),
    approvedTime: i18n.t("replenishmentRequests.requestDetails.approvedTime"),
    rejectedTime: i18n.t("replenishmentRequests.requestDetails.rejectedTime"),
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="container-fluid mt-5">
          <div className="mb-4">
            <div className="card-header py-3">
              <h6 className="back-btn" onClick={goBack}>
                {text.backBtn}
              </h6>
              <h6 className="m-0 font-weight-bold txt-primary">
                {"Request Details"}
              </h6>
            </div>

            <Card style={{ width: "100%", height: "100%" }}>
              <Form
                className="mt-4 mb-4 px-4"
                action=""
                onKeyDown={handleKeyDown}
              >
                <Row className="mt-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.requestID}
                      <span className="fs-sm">{requestId}</span>{" "}
                    </h5>
                  </Col>
                  <Col className="col-lg-6">
                    <h5>
                      {text.requestTime}
                      <span>{formatDateTime(createdAt)}</span>{" "}
                    </h5>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.storeName}
                      <span className="fs-sm">{sublocationName}</span>{" "}
                    </h5>
                  </Col>
                  {approvalStatus === "approved" && (
                    <Col className="col-lg-6">
                      <h5>
                        {text.approvedTime}
                        <span>{formatDateTime(updatedAt)}</span>{" "}
                      </h5>
                    </Col>
                  )}
                  {approvalStatus === "rejected" && (
                    <Col className="col-lg-6">
                      <h5>
                        {text.rejectedTime}
                        <span>{formatDateTime(updatedAt)}</span>{" "}
                      </h5>
                    </Col>
                  )}
                </Row>
                <Row className="mt-4">
                  <Col className="col-lg-6">
                    <InputField
                      type="text"
                      placeholder="Search with SKU ID..."
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      icon={<SearchIcon />}
                    />
                  </Col>
                </Row>

                <Row className="mt-5">
                  {searchLoading ? (
                    <Loader />
                  ) : (
                    <ReplenishmentRequestDetailsTable
                      headers={replenishmentRequestDetailsTableHeaders}
                      data={filteredItems}
                      handleQuantityChange={handleQuantityChange}
                      updateQuantity={updateQuantity}
                      toggleIsEditing={toggleIsEditing}
                    />
                  )}
                </Row>

                {approvalStatus === "pending" ? (
                  <div className="d-flex justify-content-center mt-5 ">
                    <div className="px-3">
                      <PrimaryButton
                        text={text.approveBtn}
                        className="mt-5"
                        onClick={(e) => {
                          e.preventDefault();
                          handleApprove();
                        }}
                      />
                    </div>
                    <div>
                      <PrimaryButton
                        text={text.rejectBtn}
                        className="reject-btn mt-5"
                        onClick={(e) => {
                          e.preventDefault();
                          handleReject();
                        }}
                      />
                    </div>
                  </div>
                ) : null}
              </Form>
            </Card>
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              data={totalFilteredCount}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ReplenishmentRequestDetails;
